'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'thumbtack';
var width = 384;
var height = 512;
var aliases = [128204,128392,"thumb-tack"];
var unicode = 'f08d';
var svgPathData = 'M75.4 189.4C37.5 222.2 10.7 269.5 2.6 320 .9 330.6 0 341.3 0 352l384 0c0-10.7-.9-21.4-2.6-32-8.1-50.5-34.9-97.8-72.8-130.6L298.1 32 352 32 352 0 32 0 32 32 85.9 32 75.4 189.4zM117.9 32l148.1 0 10.6 159.5 .9 13.3 10.1 8.7c31.1 26.9 53.4 65.4 61.2 106.4L35.1 320c7.8-41 30.1-79.4 61.2-106.4l10.1-8.7 .9-13.3 10.6-159.5zM176 400l0 144 32 0 0-144-32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faThumbtack = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;